'use client';

// shared imports
import { useI18n } from '@fshr/context/i18n-context';
import { cn } from '@fshr/shared-react';
import { useProfile } from '@profiles/lib/context/profile-context';
import { getConfig } from '@fshr/shared-react';

// local imports
import ProfileSubNavLink, { type ProfileSubNavLinkProps } from './profile-sub-nav-link';

export default function ProfileSubNav() {
	const { t, localeLink } = useI18n();
	const { profile } = useProfile();
	const { FSHR_PUBLIC_RESERVATIONS_BASE_URL } = getConfig();

	const links = [
		{ label: t('Overview'), href: localeLink('/profile/'), requiresFullAuthentication: false },

		{
			label: t('My Stays'),
			href: localeLink(`/profile/my-stays/`),
			requiresFullAuthentication: false,
			showActive: (pathname: string) => pathname.includes('/profile/my-stays/'),
		},

		profile?.extension?.propertyOwned && {
			label: t('My Residences'),
			href: `${FSHR_PUBLIC_RESERVATIONS_BASE_URL}${localeLink('/living')}`,
			requiresFullAuthentication: true,
		},

		profile?.hasMembership && {
			label: t('Memberships'),
			href: `/profile/memberships`,
			requiresFullAuthentication: false,
			showActive: (pathname: string) => pathname.includes('/profile/memberships/'),
		},

		{
			label: t('Account & Preferences'),
			href: localeLink(`/profile/account/info/`),
			showActive: (pathname: string) => pathname.includes('/profile/account/'),
		},

		profile?.isEmployee && {
			label: t('Employee Travel'),
			href: `${FSHR_PUBLIC_RESERVATIONS_BASE_URL}${localeLink('/profile/employee')}`,
			requiresFullAuthentication: true,
		},
	].filter(Boolean) as (ProfileSubNavLinkProps & { label: string })[];

	return (
		<div className="hidden header:block h-0">
			<nav className="h-[56px] bg-neutral-200/90 px-[110px] backdrop-blur overflow-x-auto no-scrollbar snap-x">
				<ul className="flex flex-row flex-nowrap gap-300">
					{links.map(({ label, href, requiresFullAuthentication, showActive }, index) => (
						<li
							key={label}
							className={cn('flex flex-row gap-300 items-center snap-center', {
								"after:content-[''] after:h-200 after:border-r after:border-r-neutral-900":
									index === 0,
							})}
						>
							<ProfileSubNavLink
								href={href}
								requiresFullAuthentication={requiresFullAuthentication}
								showActive={showActive}
							>
								{label}
							</ProfileSubNavLink>
						</li>
					))}
				</ul>
			</nav>
		</div>
	);
}
